import { render, staticRenderFns } from "./RegisterButtonGroup.vue?vue&type=template&id=68dce308&scoped=true"
import script from "./RegisterButtonGroup.vue?vue&type=script&lang=ts"
export * from "./RegisterButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./RegisterButtonGroup.vue?vue&type=style&index=0&id=68dce308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dce308",
  null
  
)

export default component.exports